var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 462,
        visible: _vm.visible,
        footer: null
      },
      on: { cancel: _vm.handleCancel }
    },
    [
      _c(
        "div",
        {
          staticClass: "product-switch",
          on: { click: _vm.handleSwitchChange }
        },
        [
          _c(
            "svg",
            {
              class: _vm.check ? "product-switch-active" : "",
              attrs: {
                id: "ic-24-list",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "currentColor",
                width: "36px",
                height: "36px",
                viewBox: "0 0 24 24"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Group_18712",
                    "data-name": "Group 18712",
                    transform: "translate(-460 -348)"
                  }
                },
                [
                  _c("rect", {
                    attrs: {
                      id: "Rectangle_10139",
                      "data-name": "Rectangle 10139",
                      width: "24",
                      height: "24",
                      transform: "translate(460 348)",
                      fill: "none"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      id: "Union_398",
                      "data-name": "Union 398",
                      d:
                        "M155,1430.026a1,1,0,1,1,0-2h10a1,1,0,1,1,0,2Zm-4,0a1,1,0,1,1,0-2h.01a1,1,0,1,1,0,2Zm4-6a1,1,0,0,1,0-2h10a1,1,0,0,1,0,2Zm-4,0a1,1,0,0,1,0-2h.01a1,1,0,0,1,0,2Zm4-6a1,1,0,1,1,0-2h10a1,1,0,1,1,0,2Zm-4,0a1,1,0,1,1,0-2h.01a1,1,0,1,1,0,2Z",
                      transform: "translate(314 -1063.026)"
                    }
                  })
                ]
              )
            ]
          ),
          _c(
            "svg",
            {
              class: !_vm.check ? "product-switch-active" : "",
              attrs: {
                id: "ic-24-grid",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "currentColor",
                width: "36px",
                height: "36px",
                viewBox: "0 0 24 24"
              }
            },
            [
              _c("rect", {
                attrs: { id: "area", width: "24", height: "24", fill: "none" }
              }),
              _c("path", {
                attrs: {
                  id: "Union_396",
                  "data-name": "Union 396",
                  d:
                    "M216.643,1432a1.5,1.5,0,0,1-1.5-1.5v-3.856a1.5,1.5,0,0,1,1.5-1.5H220.5a1.5,1.5,0,0,1,1.5,1.5v3.856a1.5,1.5,0,0,1-1.5,1.5Zm.3-1.8H220.2v-3.257h-3.257ZM207.5,1432a1.5,1.5,0,0,1-1.5-1.5v-3.856a1.5,1.5,0,0,1,1.5-1.5h3.856a1.5,1.5,0,0,1,1.5,1.5v3.856a1.5,1.5,0,0,1-1.5,1.5Zm.3-1.8h3.257v-3.257H207.8Zm8.842-7.343a1.5,1.5,0,0,1-1.5-1.5V1417.5a1.5,1.5,0,0,1,1.5-1.5H220.5a1.5,1.5,0,0,1,1.5,1.5v3.857a1.5,1.5,0,0,1-1.5,1.5Zm.3-1.8H220.2V1417.8h-3.257Zm-9.443,1.8a1.5,1.5,0,0,1-1.5-1.5V1417.5a1.5,1.5,0,0,1,1.5-1.5h3.856a1.5,1.5,0,0,1,1.5,1.5v3.857a1.5,1.5,0,0,1-1.5,1.5Zm.3-1.8h3.257V1417.8H207.8Z",
                  transform: "translate(-202 -1411.974)"
                }
              })
            ]
          )
        ]
      ),
      _c(
        "div",
        {
          class: [
            "product-list-root",
            _vm.check ? "product-horizontal-list" : "product-vertical-list"
          ]
        },
        _vm._l(_vm.record, function(item) {
          return _c("figure", { key: item.id, staticClass: "product-item" }, [
            _c("picture", {
              staticClass: "product-cover",
              style: {
                backgroundImage:
                  "url(" + _vm.getImgViewCode(item.thumbnail) + ")"
              }
            }),
            _c("figcaption", { staticClass: "product-information" }, [
              _c("div", { staticClass: "product-name" }, [
                _vm._v("\n          " + _vm._s(item.name) + "\n        ")
              ]),
              _c("dl", { staticClass: "product-field" }, [
                _c("dt", { staticClass: "product-field-label" }, [
                  _vm._v("供應商家")
                ]),
                _c("dl", { staticClass: "product-field-value" }, [
                  _vm._v(_vm._s(item.businessName))
                ])
              ]),
              _c("dl", { staticClass: "product-field" }, [
                _c("dt", { staticClass: "product-field-label" }, [
                  _vm._v(_vm._s(item.virtual == 0 ? "尚餘數量" : "捐助總額"))
                ]),
                _c("dl", { staticClass: "product-field-value" }, [
                  _vm._v(_vm._s(item.virtual == 0 ? "1000組" : "1000元"))
                ])
              ]),
              _c("dl", { staticClass: "product-field" }, [
                _c("dt", { staticClass: "product-field-label" }, [
                  _vm._v("市售價")
                ]),
                _c("dl", { staticClass: "product-field-value" }, [
                  _vm._v(
                    _vm._s(item.marketPrice ? "$" + item.marketPrice : "$1000")
                  )
                ])
              ]),
              _c("dl", { staticClass: "product-action" }, [
                _c("dt", { staticClass: "product-price" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "currentColor",
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16",
                        size: "16",
                        color: "#D5A85F",
                        "data-v-5d0cdcb4": ""
                      }
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "ic-honhaimoney-red",
                            transform: "translate(0 0.296)"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "Subtraction_9",
                              "data-name": "Subtraction 9",
                              d:
                                "M-2494,2102.7a8.009,8.009,0,0,1-8-8,8.009,8.009,0,0,1,8-8,8.009,8.009,0,0,1,8,8A8.009,8.009,0,0,1-2494,2102.7Zm-1.508-7.333h3.015v3.333h1.993v-8h-1.993v3.179h-3.015V2090.7h-1.992v8h1.992v-3.333Z",
                              transform: "translate(2502 -2087)"
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v("\n            " + _vm._s(item.price) + "\n          ")
                ]),
                _c("dl", { staticClass: "product-buy" }, [_vm._v("立即訂")])
              ])
            ])
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }